module.exports = "33c6222cfbd417af74a60c7c57e93755.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/button_hover.wav
// module id = 96
// module chunks = 0